export default class extends Controller {
    unblock(event) {
      event.preventDefault();
      fetch(event.target.href, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(data => {
        if (data.blocked_html) {
          const blockedStatusElement = document.querySelector('[data-blocked-status]');
          if (blockedStatusElement) {
            blockedStatusElement.innerHTML = data.blocked_html;
          }
        }
        const taskWasUnblocked = new CustomEvent('task-unblock:success', { detail: { id: data.task.id } });
        document.dispatchEvent(taskWasUnblocked);
      })
      .catch(error => console.error('Error:', error));
    }
  }



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/blocked-task-controller.js